import { getAPI } from '../utils/ApiFunctions';
import { getAccessToken } from '../utils/Auth.util';
import { MICRO_FRONTEND_STARGATE_KEY } from '../constants';

class DisclaimerService {
    getGenericDisclaimers = async () => {
        let url = process.env.GENERIC_DISCLAIMERS;
        const token = await getAccessToken(MICRO_FRONTEND_STARGATE_KEY);

        return getAPI(url, { counts: false }, token);
    };
}

export default new DisclaimerService();
